module.exports = __webpack_public_path__ + "static/img/bg-5.fd7f980.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/pc/imgs/bg-5.jpg
// module id = Cc0D
// module chunks = 13